import { getTranslation } from "orion-components/i18n";
import { useSelector } from "react-redux";
import { getSelectedContextData } from "orion-components/Profiles/Selectors";

const getButtons = (user, contextId, appId, actions, readOnly) => {
	const { applications } = user;

	const entity = useSelector(state => getSelectedContextData(state)(contextId, "entity"));
	const trackHistory = useSelector(state => getSelectedContextData(state)(contextId, "trackHistory"));
	const { isPublic, entityType, showFOV = false, entityData, sharedWith } = entity;
	const hasReports = applications.find(app => app.appId === "reports-app");

	switch (entityType) {
		case "track":
			return [
				{
					name: getTranslation("global.profiles.entityProfile.main.trackHistory"),
					icon: "history",
					toggled: !!trackHistory,
					viewable: true
				},
				{
					name: getTranslation("global.profiles.entityProfile.main.tetraRadioCall"), // "Zetron Call"
					icon: "phone",
					toggled: false,
					viewable: user.zetronSystemAvailable || false
				},
				{
					name: getTranslation("global.profiles.entityProfile.main.pinTo"),
					icon: "star",
					toggled: false,
					viewable: !readOnly
				},
				{
					name: getTranslation("global.profiles.entityProfile.main.edit"),
					icon: "edit",
					toggled: false,
					viewable: true
				},
				{
					name: getTranslation("global.profiles.entityProfile.main.hide"),
					icon: "delete",
					toggled: false,
					viewable: !readOnly
				}
			];
		case "shapes":
			return [
				{
					name: getTranslation("global.profiles.entityProfile.main.pinTo"),
					icon: "star",
					toggled: false,
					viewable: !readOnly
				},
				{
					name: getTranslation("global.profiles.entityProfile.main.edit"),
					icon: "edit",
					toggled: false,
					viewable:
						!readOnly &&
						appId !== "cameras-app" &&
						(entity.entityData.displayType !== "facility" || appId === "facilities-app") &&
						user.integrations &&
						user.integrations.find(int => int.intId === entity.feedId) &&
						user.integrations.find(int => int.intId === entity.feedId).permissions &&
						user.integrations.find(int => int.intId === entity.feedId).permissions.includes("manage")
				},
				{
					name: getTranslation("global.profiles.entityProfile.main.delete"),
					icon: "delete",
					toggled: false,
					viewable:
						!readOnly &&
						user.integrations &&
						user.integrations.find(int => int.intId === entity.feedId) &&
						user.integrations.find(int => int.intId === entity.feedId).permissions &&
						user.integrations.find(int => int.intId === entity.feedId).permissions.includes("manage")
				},
				{
					name: getTranslation("global.profiles.entityProfile.main.hide"),
					icon: "delete",
					toggled: false,
					viewable: !readOnly && isPublic
				}
			];
		case "camera": {
			const buttons = [];
			if (appId && appId.toLowerCase() === "cameras-app") {
				let facilityHidden = true;
				actions.some(action => {
					if (action?.nameText?.toLowerCase() === "facility") {
						facilityHidden = false;
						return true;
					} else {
						return false;
					}
				});
				buttons.push({
					name: getTranslation("global.profiles.cameraProfile.facility"),
					viewable:
						!readOnly &&
						entityData.displayType &&
						entityData.displayType.toLowerCase() === "facility" &&
						entityData.displayTargetId,
					icon: "homework",
					disabled: facilityHidden
				});
			}
			return [
				...buttons,
				{
					name: getTranslation("global.profiles.cameraProfile.launch"),
					icon: "launch",
					toggled: false,
					viewable: !readOnly && appId !== "cameras-app"
				},
				{
					name: showFOV
						? getTranslation("global.profiles.cameraProfile.hideFOV")
						: getTranslation("global.profiles.cameraProfile.showFOV"),
					icon: "network_wifi",
					toggled: showFOV,
					viewable: appId === "map-app" || appId === "events-app"
				},
				{
					name: getTranslation("global.profiles.cameraProfile.adminPage"),
					icon: "settings",
					toggled: false,
					viewable: !readOnly
				},
				{
					name: getTranslation("global.profiles.entityProfile.main.pinTo"),
					icon: "star",
					toggled: false,
					viewable: !readOnly
				},
				{
					name: getTranslation("global.profiles.entityProfile.main.edit"),
					icon: "edit",
					toggled: false,
					viewable:
						!readOnly &&
						user.integrations &&
						user.integrations.find(int => int.intId === entity.feedId) &&
						user.integrations.find(int => int.intId === entity.feedId).permissions &&
						user.integrations.find(int => int.intId === entity.feedId).permissions.includes("manage")
				},
				{
					name: getTranslation("global.profiles.entityProfile.main.hide"),
					icon: "delete",
					toggled: false,
					viewable: !readOnly
				}
			];
		}

		case "device": {
			const buttons = [];
			if (appId && appId.toLowerCase() === "cameras-app") {
				let facilityHidden = true;
				actions.some(action => {
					if (action?.nameText?.toLowerCase() === "facility") {
						facilityHidden = false;
						return true;
					} else {
						return false;
					}
				});
				buttons.push({
					name: getTranslation("global.profiles.cameraProfile.facility"),
					viewable:
						!readOnly &&
						entityData.displayType &&
						entityData.displayType.toLowerCase() === "facility" &&
						entityData.displayTargetId,
					icon: "homework",
					disabled: facilityHidden
				});
			}

			return [
				...buttons,
				{
					name: getTranslation("global.profiles.deviceProfile.adminPage"),
					icon: "settings",
					toggled: false,
					viewable: !readOnly
				},
				{
					name: getTranslation("global.profiles.entityProfile.main.pinTo"),
					icon: "star",
					toggled: false,
					viewable: !readOnly
				},
				{
					name: getTranslation("global.profiles.entityProfile.main.edit"),
					icon: "edit",
					toggled: false,
					viewable:
						!readOnly &&
						user.integrations &&
						user.integrations.find(int => int.intId === entity.feedId) &&
						user.integrations.find(int => int.intId === entity.feedId).permissions &&
						user.integrations.find(int => int.intId === entity.feedId).permissions.includes("manage")
				},
				{
					name: getTranslation("global.profiles.entityProfile.main.hide"),
					icon: "delete",
					toggled: false,
					viewable: !readOnly
				}
			];
		}

		case "compositeDevice": {
			const buttons = [];
			if (appId && appId?.toLowerCase() === "cameras-app") {
				let facilityHidden = true;
				actions?.some(action => {
					if (action?.nameText.toLowerCase() === "facility") {
						facilityHidden = false;
						return true;
					} else {
						return false;
					}
				});
				buttons.push({
					name: getTranslation("global.profiles.cameraProfile.facility"),
					viewable:
						!readOnly &&
						entityData?.displayType &&
						entityData?.displayType.toLowerCase() === "facility" &&
						entityData?.displayTargetId,
					icon: "homework",
					disabled: facilityHidden
				});
			}
			return [
				...buttons,
				{
					name: getTranslation("global.profiles.entityProfile.main.pinTo"),
					icon: "star",
					toggled: false,
					viewable: !readOnly
				},
				{
					name: getTranslation("global.profiles.entityProfile.main.edit"),
					icon: "edit",
					toggled: false,
					viewable: !readOnly
				},
				{
					name: getTranslation("global.profiles.entityProfile.main.hide"),
					icon: "delete",
					toggled: false,
					viewable: !readOnly
				}
			];
		}

		case "event": {
			const canManageEvents = user?.applications
				?.find(app => app.appId === "events-app")
				?.permissions?.includes("manage");

			const canShareEvents = user?.applications
				?.find(app => app.appId === "events-app")
				?.permissions?.includes("share");

			const { isTemplate, id } = entity;
			let isTemplateToggled = false;
			if (isTemplate) {
				const eventTemplateFavorites = useSelector(state => state.appState?.userGlobal?.eventTemplateFavorites);
				if (eventTemplateFavorites?.length > 0) {
					isTemplateToggled = eventTemplateFavorites.includes(id);
				}
			}

			return [
				{
					name: getTranslation("global.profiles.eventProfile.main.favorite"),
					icon: "star",
					toggled: isTemplateToggled,
					viewable: !readOnly && isTemplate,
					toggleColor: "#F8F29F"
				},
				{
					name: getTranslation("global.profiles.eventProfile.main.launch"),
					icon: "launch",
					toggled: false,
					viewable: !readOnly && appId !== "events-app"
				},
				{
					name: getTranslation("global.profiles.eventProfile.main.report"),
					icon: "description",
					toggled: false,
					viewable: !readOnly && hasReports
				},
				{
					name:
						isPublic && !canShareEvents
							? getTranslation("global.profiles.eventProfile.main.shared")
							: getTranslation("global.profiles.eventProfile.main.share"),
					icon: "share",
					toggled: sharedWith.length > 0,
					disabled: isPublic && !canShareEvents,
					viewable: !readOnly && canShareEvents
				},
				{
					name: getTranslation("global.profiles.entityProfile.main.edit"),
					icon: "edit",
					toggled: false,
					viewable: !readOnly && canManageEvents
				},
				{
					name: getTranslation("global.profiles.entityProfile.main.delete"),
					icon: "delete",
					toggled: false,
					viewable: !readOnly && entity.ownerOrg === user.orgId && canManageEvents
				}
			];
		}
		case "facility": {
			const buttons = actions.map(action => {
				switch (action.nameText.toLowerCase()) {
					case "launch":
						return {
							name: getTranslation("global.profiles.facilityProfile.main.launch"),
							icon: "launch",
							toggled: false,
							viewable: !readOnly && appId !== "facilities-app"
						};
					case "edit":
						return {
							name: getTranslation("global.profiles.entityProfile.main.edit"),
							icon: "edit",
							toggled: false,
							viewable:
								!readOnly &&
								user.integrations &&
								user.integrations.find(int => int.intId === entity.feedId) &&
								user.integrations.find(int => int.intId === entity.feedId).permissions &&
								user.integrations
									.find(int => int.intId === entity.feedId)
									.permissions.includes("manage")
						};
					case "hide":
						return {
							name: getTranslation("global.profiles.entityProfile.main.hide"),
							icon: "delete",
							toggled: false,
							viewable: !readOnly
						};
					case "pin to": {
						return {
							name: getTranslation("global.profiles.entityProfile.main.pinTo"),
							icon: "star",
							toggled: false,
							viewable: !readOnly
						};
					}
					case "delete": {
						return {
							name: getTranslation("global.profiles.entityProfile.main.delete"),
							icon: "delete",
							toggled: false,
							viewable: !readOnly
						};
					}
					default:
						break;
				}
			});

			return buttons;
		}
		default:
			break;
	}
};

export default getButtons;
